module.exports = __webpack_public_path__ + "img/owners_manual.19742cb2.png";